<template>
  <div class="rule">
    <p>
      活动时间：5月1日-5月5日23:59	<br>
      活动说明：本次活动仅限官方安卓和IOS玩家参与，请使用对应帐号参与本次活动；	<br>
      每日签到、每日邀请1人参与活动，每日游戏内活跃度满值均可获得对应积分；	<br>
      获得的游戏内奖励将发放至绑定角色邮箱；	<br>
      积分抽奖游戏内奖励可多次获得，每种实物奖品只可获取一次；	<br>
      获得实物奖励的玩家请填写正确的收货地址，奖品将于活动结束后7个工作日之内发放；	<br>
      如有疑问请添加征途2手游微信公众号：zhengtu2m进行咨询。<br>
    </p>
    <slot :btns="btns" />

  </div>
</template>

<script>
export default {
  name: 'Rule',
  data() {
    return {
      btns: {
        btn1: '下载游戏',
        btn2: '进入官网'
      }
    }
  },
  mounted() {

  }

};
</script>

<style lang="stylus" scoped>
  .cp-loading
    width: 100%
    height 100%
    top 0
    left 0
    right 0
    bottom 0
    display flex
    justify-content center
    align-items center
    position fixed
    z-index 11
    background-color rgba(0, 0, 0, 0.9)
    .container
      width: 4.00rem;
      height: 2.00rem;
      left: 50%;
      top: 50%;
      margin: -2.00rem 0 0 -2.00rem;
      position: absolute;
      text-align: center;
      .ball
        background-color: rgba(0,0,0,0);
        border: 0.1rem solid rgba(0,183,229,0.9);
        border-color: rgba(0, 0, 0, 0) #fff #fff rgba(0, 0, 0, 0);
        opacity: .9;
        border-top: 0.1rem solid rgba(0,0,0,0);
        border-left: 0.1rem solid rgba(0,0,0,0);
        border-radius: 1rem;
        box-shadow: 0 0 0.7rem #fff;
        width: 1rem;
        height: 1rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -0.5rem 0 0 -0.5rem;
        animation: spin .5s infinite linear;
        &-1
          box-shadow: 0 0 0.15rem #fff;
          width: 0.60rem;
          height: 0.60rem;
          margin: -0.3rem 0 0 -0.3rem;
          animation: spinoff .5s infinite linear;

  @keyframes spin
    0%
      transform rotate(0deg);
    100%
      transform rotate(360deg);

  @keyframes spinoff
    0%
      transform rotate(0deg);
    100%
      transform rotate(-360deg);
</style>
